// extracted by mini-css-extract-plugin
export default {"loader":"DotLineLoader_loader__rNvWU","dot":"DotLineLoader_dot__I8okr","dotSpin":"DotLineLoader_dotSpin__rKfAu"};